import React, { useState } from 'react'
import 'animate.css/animate.compat.css';
import { Routes, Route, BrowserRouter, useLocation } from 'react-router-dom'
import Header from './general/Header';
import Footer from './general/Footer';
import ScrollTop from './general/ScrollTop';
import PageNotFound from './general/PageNotFound';

// general
import ResponseMsg from './general/ResponseMsg';
import Loading from './general/Loading';

// pages
import Home from './components/Home';
import About from './components/About';
import Academics from './components/Academics';
import Contact from './components/Contact';
import SchoolLogin from './components/SchoolLogin';
import PrivacyPolicy from './components/PrivacyPolicy';

// web imports
import WebSidebar from './webpanel/WebSidebar';
import WebDashboard from './webpanel/WebDashboard';
import NoticeBoard from './webpanel/NoticeBoard';
import Achievements from './webpanel/Achievements';
import BlogPost from './webpanel/BlogPost';
import OurAchievements from './components/Achievements';


// institute panel
import AdminLogin from './Admin/AdminLogin';
import AdminDashboard from './Admin/AdminDashboard';
import SidePanel from './Admin/SidePanel';
import InsProfile from './Admin/InsProfile';
import AccountDetail from './Admin/AccountDetail';
import FeeParticular from './Admin/FeeParticular';
import FeeStructure from './Admin/FeeStructure';
import AddNewEmployee from './Admin/employee/AddNewEmployee';
import AllEmployee from './Admin/employee/AllEmployee';
import EditEmployee from './Admin/employee/EditEmployee';
import AllClasses from './Admin/classes/AllClasses';
import AssignClassTeacher from './Admin/classes/AssignClassTeacher';
import ClassSubjects from './Admin/subjects/ClassSubjects';
import AssignSubjects from './Admin/subjects/AssignSubjects';
import EmployeeIdCard from './Admin/employee/EmployeeIdCard';
import AddStudent from './Admin/students/AddStudent';
import AllStudents from './Admin/students/AllStudents';
import AcademicYear from './Admin/AcademicYear';
import EditStudent from './Admin/students/EditStudent';
import StudentIdCard from './Admin/students/StudentIdCard';
import StudentAttendance from './Admin/attendance/StudentAttendance';
import EmployeeAttendance from './Admin/attendance/EmployeeAttendance';
import StdAtdReport from './Admin/attendance/StdAtdReport';
import EmpAtdReport from './Admin/attendance/EmpAtdReport';
import CollectFee from './Admin/fees/CollectFee';
import FeeReport from './Admin/fees/FeeReport';
import AddHomework from './Admin/homework/AddHomework';
import ListHomework from './Admin/homework/ListHomework';
import ReportHomework from './Admin/homework/ReportHomework';


import Lesson from './Admin/lessonplan/Lesson';
import Topic from './Admin/lessonplan/Topic';
import LessPlanoverview from './Admin/lessonplan/LessPlanoverview';
import UploadContent from './Admin/studymaterial/UploadContent';
import Assignment from './Admin/studymaterial/Assignment';
import Syllabus from './Admin/studymaterial/Syllabus';
import ExamType from './Admin/exam/ExamType';
import ExamSetup from './Admin/exam/ExamSetup';
import ExamSchedule from './Admin/exam/ExamSchedule';
import ExamAttendance from './Admin/exam/ExamAttendance';
import ExamReport from './Admin/exam/ExamAttendenceReport';
import QuestionBank from './Admin/exam/QuestionBank';
import OnlineExam from './Admin/exam/OnlineExam';


import Payroll from './Admin/employee/Payroll';
import ApplyLeave from './Admin/leave/ApplyLeave';
import ApproveLeave from './Admin/leave/ApproveLeave';
import DefineLeave from './Admin/leave/DefineLeave';
import Appointments from './Admin/visitMeeting/Appointments';
import Grievances from './Admin/visitMeeting/Grievances';
import CreateTimeTable from './Admin/timetable/CreateTimeTable';
import TeacherAllocation from './Admin/timetable/TeacherAllocation';
import VisitorBook from './Admin/visitMeeting/Visits';
import Notices from './Admin/visitMeeting/Notice';


// Teacher panel
import TeacherLogin from './Admin/teacher/TeacherLogin';
import ClassTimeTable from './Admin/timetable/ClassTimeTable';
import OtherDownloads from './Admin/studymaterial/OtherDownloads';


// Library Panel
import AddBook from './Admin/library/AddBook';
import BookList from './Admin/library/BookList';
import AddMember from './Admin/library/AddMember';
import IssueReturn from './Admin/library/IssueReturn';


// hotel panel
import AddDormitory from './Admin/dormitory/AddDormitory';
import DormitoryRoom from './Admin/dormitory/DormitoryRoom';
import AssignHostelRoom from './Admin/dormitory/AssignHostelRoom';
import DormitoryReport from './Admin/dormitory/DormitoryReport';


// vehicle panel
import VehicleRoutes from './Admin/transport/Routes';
import Vehicle from './Admin/transport/Vehicle';
import AssignVehicle from './Admin/transport/AssignVehicle';
import TransportReport from './Admin/transport/TransportReport';
import Remark from './Admin/homework/Remark';
import Register from './components/Register';
import RegList from './Admin/students/RegList';
import OnlineExamReport from './Admin/exam/OnlineExamReport';
import OfflineReportCard from './Admin/exam/OfflineReportCard';
import PrepareReportCard from './Admin/exam/PrepareReportCard';


const App = () => {
    const collapsed = false;
  const [response, setResponse] = useState({ message: '', status: 'success' });
  const [loading, setLoading] = useState(false);
    const isWebAdmin = localStorage.getItem(('isWebAdmin'));
    const isInsAdmin = localStorage.getItem(('isInsAdmin'));
const userData = JSON.parse(localStorage.getItem('userData'))?.[0];
// console.log(userData);

     const location = useLocation();
    const isInsLogin = location.pathname === '/institute-login' || location.pathname === '/staff-login';


  return (
    <>
<ScrollTop />

{!isInsAdmin && !isWebAdmin && (
<>
{!isInsLogin && 
      <Header /> }
      <Routes>
<Route exact path='/' element={<Home setResponse={setResponse} setLoading={setLoading} />} />
<Route exact path='/about' element={<About />} />
<Route exact path='/academics' element={<Academics setLoading={setLoading} />} />
<Route exact path='/achievements' element={<OurAchievements setLoading={setLoading} setResponse={setResponse} />} />
<Route exact path='/contact' element={<Contact />} />
<Route exact path='/privacy-policy' element={<PrivacyPolicy />} />
<Route exact path='/school-login' element={<SchoolLogin setResponse={setResponse} setLoading={setLoading} />} />
<Route exact path='/institute-login' element={<AdminLogin setLoading={setLoading} />} />
<Route exact path='/staff-login' element={<TeacherLogin setLoading={setLoading} />} />
<Route exact path='/student-registration' element={<Register setLoading={setLoading} />} />
        <Route exact path='*' element={<PageNotFound />} />

      </Routes>
      {!isInsLogin && 
      <Footer /> }
</>
)}


{isWebAdmin && (
  <>
            <WebSidebar isWebAdmin={isWebAdmin} />
                      <div className={`dashboard-sidebar-right ${collapsed ? "collapsed" : ""}`}>
            <Routes>
              <Route exact path='/' element={<WebDashboard setLoading={setLoading} />} />
              <Route exact path='/web-dashboard' element={<WebDashboard setLoading={setLoading} />} />
              <Route exact path='/notice-board' element={<NoticeBoard setLoading={setLoading} />} />
              <Route exact path='/achievements' element={<Achievements setLoading={setLoading} />} />
              <Route exact path='/blog-post' element={<BlogPost setLoading={setLoading} />} />

</Routes>
</div>
</>
)}


{isInsAdmin && (
<>
            <SidePanel isInsAdmin={isInsAdmin} userData={userData} />

                      <div className={`dashboard-sidepanel-right ${collapsed ? "collapsed" : ""}`}>
<Routes>
                <Route exact path='/' element={<AdminDashboard setLoading={setLoading} userData={userData} />} />
              <Route exact path='/admin/dashboard' element={<AdminDashboard setLoading={setLoading} userData={userData} />} />
              <Route exact path='/admin/profile' element={<InsProfile setLoading={setLoading} userData={userData} />} />
              <Route exact path='/admin/academic-year' element={<AcademicYear setLoading={setLoading} />} />
              <Route exact path='/admin/fee-particular' element={<FeeParticular setLoading={setLoading} />} />
              <Route exact path='/admin/fee-structure' element={<FeeStructure setLoading={setLoading} />} />
              <Route exact path='/admin/account-detail' element={<AccountDetail setLoading={setLoading} />} />              


{/* Library Routes */}
              <Route exact path='/admin/add-book' element={<AddBook setLoading={setLoading} />} />              
              <Route exact path='/admin/book-list' element={<BookList setLoading={setLoading} />} />              
              <Route exact path='/admin/add-member' element={<AddMember setLoading={setLoading} userData={userData} />} />              
              <Route exact path='/admin/issue-return' element={<IssueReturn setLoading={setLoading} />} />              


{/* Vehicle Routes */}
              <Route exact path='/admin/add-routes' element={<VehicleRoutes setLoading={setLoading} />} />              
              <Route exact path='/admin/add-vehicle' element={<Vehicle setLoading={setLoading} />} />              
              <Route exact path='/admin/assign-vehicle' element={<AssignVehicle setLoading={setLoading} />} />              
              <Route exact path='/admin/transport-report' element={<TransportReport setLoading={setLoading} />} />              


{/* Hostel Routes */}
              <Route exact path='/admin/add-hostel' element={<AddDormitory setLoading={setLoading} />} />              
              <Route exact path='/admin/hostel-rooms' element={<DormitoryRoom setLoading={setLoading} />} />              
              <Route exact path='/admin/assign-rooms' element={<AssignHostelRoom setLoading={setLoading} />} />              
              <Route exact path='/admin/hostel-report' element={<DormitoryReport setLoading={setLoading} />} />              


{/* employee routes */}
              <Route exact path='/admin/add-employee' element={<AddNewEmployee setLoading={setLoading} />} />
              <Route exact path='/admin/edit-employee' element={<EditEmployee setLoading={setLoading} />} />
              <Route exact path='/admin/all-employees' element={<AllEmployee setLoading={setLoading} userData={userData} />} />
              <Route exact path='/admin/staff-icards' element={<EmployeeIdCard setLoading={setLoading} userData={userData} />} />

{/* class routes */}
              <Route exact path='/admin/assign-class-teacher' element={<AssignClassTeacher setLoading={setLoading} />} />
              <Route exact path='/admin/all-classes' element={<AllClasses setLoading={setLoading} />} />

{/* subject routes */}
              <Route exact path='/admin/class-subjects' element={<ClassSubjects setLoading={setLoading} />} />
              <Route exact path='/admin/assign-subjects' element={<AssignSubjects setLoading={setLoading} />} />

{/* Attendance routes */}
              <Route exact path='/admin/students-attendance' element={<StudentAttendance setLoading={setLoading} />} />
              <Route exact path='/admin/employees-attendance' element={<EmployeeAttendance setLoading={setLoading} />} />
              <Route exact path='/admin/students-attendance-report' element={<StdAtdReport setLoading={setLoading} />} />
              <Route exact path='/admin/employees-attendance-report' element={<EmpAtdReport setLoading={setLoading} userData={userData} />} />


{/* Time Table Routes */}
              <Route exact path='/admin/create-time-table' element={<CreateTimeTable setLoading={setLoading} />} />
              <Route exact path='/admin/teacher-allocation' element={<TeacherAllocation setLoading={setLoading} userData={userData} />} />
              <Route exact path='/admin/class-time-table' element={<ClassTimeTable setLoading={setLoading} />} />


{/* Student routes */}
              <Route exact path='/admin/add-student' element={<AddStudent setLoading={setLoading} />} />
              <Route exact path='/admin/edit-student' element={<EditStudent setLoading={setLoading} />} />
              <Route exact path='/admin/all-students' element={<AllStudents setLoading={setLoading} />} />
              <Route exact path='/admin/student-icards' element={<StudentIdCard setLoading={setLoading} />} />
              <Route exact path='/admin/registration-list' element={<RegList setLoading={setLoading} />} />


{/* Fees routes */}
              <Route exact path='/admin/collect-fees' element={<CollectFee setLoading={setLoading} />} />
              <Route exact path='/admin/fee-report' element={<FeeReport setLoading={setLoading} />} />


              {/* HomeWork Route */}
              <Route exact path='/admin/add-homework' element={<AddHomework setLoading={setLoading} />} />
              <Route exact path='/admin/homework-list' element={<ListHomework setLoading={setLoading} />} />
              <Route exact path='/admin/homework-report' element={<ReportHomework setLoading={setLoading} />} />
              <Route exact path='/admin/student-remark' element={<Remark setLoading={setLoading} userData={userData} />} />


              {/* Lesson Plan  */}
              <Route exact path='/admin/lesson' element={<Lesson setLoading={setLoading} userData={userData} />} />
              <Route exact path='/admin/topic' element={<Topic setLoading={setLoading} userData={userData} />} />
              {/* <Route exact path='/admin/topic-overview' element={<TopicOverview setLoading={setLoading} />} />
              <Route exact path='/admin/lesson-plan' element={<LessonPlan setLoading={setLoading} />} /> */}
              <Route exact path='/admin/plan-overview' element={<LessPlanoverview setLoading={setLoading} userData={userData} />} />

              {/* StudyMaterial Route */}
              <Route exact path='/admin/upload-content' element={<UploadContent setLoading={setLoading} userData={userData} />} />
              <Route exact path='/admin/assignment' element={<Assignment setLoading={setLoading} userData={userData} />} />
              <Route exact path='/admin/syllabus' element={<Syllabus setLoading={setLoading} userData={userData} />} />
              <Route exact path='/admin/other-downloads' element={<OtherDownloads setLoading={setLoading} userData={userData} />} />

              {/* Exam Route */}

              <Route exact path='/admin/exam-type' element={<ExamType setLoading={setLoading} />} />
              <Route exact path='/admin/exam-setup' element={<ExamSetup setLoading={setLoading} />} />
              <Route exact path='/admin/exam-schedule' element={<ExamSchedule setLoading={setLoading} />} />
              <Route exact path='/admin/exam-attendance' element={<ExamAttendance setLoading={setLoading} />} />
              <Route exact path='/admin/offline-exam-report' element={<ExamReport setLoading={setLoading} />} />
              <Route exact path='/admin/offline-report-card' element={<OfflineReportCard setLoading={setLoading} />} />
              {/* <Route exact path='/admin/question-group' element={<QuestionGroup setLoading={setLoading} />} /> */}
              <Route exact path='/admin/question-bank' element={<QuestionBank setLoading={setLoading} />} />
              <Route exact path='/admin/create-exam' element={<OnlineExam setLoading={setLoading} userData={userData} />} />
              <Route exact path='/admin/online-exam-report' element={<OnlineExamReport setLoading={setLoading} userData={userData} />} />
              <Route exact path='/admin/prepare-report-card' element={<PrepareReportCard setLoading={setLoading} userData={userData} />} />
              {/* Payroll Route */}

              <Route exact path='/admin/payroll' element={<Payroll setLoading={setLoading} userData={userData} />} />

              {/* leave Route */}

              <Route exact path='/admin/apply-leave' element={<ApplyLeave setLoading={setLoading} userData={userData} />} />
              <Route exact path='/admin/approve-leave-request' element={<ApproveLeave setLoading={setLoading} />} />
              <Route exact path='/admin/leave-define' element={<DefineLeave setLoading={setLoading} />} />

              {/* visit-Meeting path */}
              <Route exact path='/admin/appointments' element={<Appointments setLoading={setLoading} userData={userData} />} />
              <Route exact path='/admin/visitor-book' element={<VisitorBook setLoading={setLoading} userData={userData} />} />

              {/* Grievances */}
              <Route exact path='/admin/grievances' element={<Grievances setLoading={setLoading} userData={userData} />} />
{/* Notice Board */}
              <Route exact path='/admin/notice-board' element={<Notices setLoading={setLoading} />} />


</Routes>
</div>
</>
)}
       

       {response.message && <ResponseMsg message={response.message} status={response.status} />}
       {/* {response2.message && <ResponseMsg2 message={response2.message} status={response2.status} />} */}
{loading && <Loading setLoading={setLoading} />}

    </>
  )
}

export default App
